<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Master Provider - Create New</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create Master Provider</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="PPOB Gateway Name"
            label-class="control-label"
            class="required"
            label-for="gateway"
          >
            <input
              v-model="item.gateway"
              v-validate="'required'"
              name="gateway"
              data-vv-as="PPOB Gateway Name"
              id="gateway"
              class="form-control"
              placeholder="PPOB Gateway Name"
            />
            <b-form-invalid-feedback id="input-gateway-feedback">{{
              veeErrors.first("gateway")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Brand Name"
            label-class="control-label"
            class="required"
            label-for="brand-name"
          >
            <input
              v-model="item.brand_name"
              v-validate="'required'"
              name="brand_name"
              data-vv-as="Brand Name"
              id="brand-name"
              class="form-control"
              placeholder="Brand Name"
            />
            <b-form-invalid-feedback id="input-brand_name-feedback">{{
              veeErrors.first("brand_name")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Description (English)"
            label-class="control-label"
            class="required"
            label-for="description-en"
          >
            <input
              v-model="item.description.en"
              v-validate="'required'"
              name="description_en"
              data-vv-as="Description (English)"
              id="description-en"
              class="form-control"
              placeholder="Description in English"
            />
            <b-form-invalid-feedback id="input-description_en-feedback">{{
              veeErrors.first("description_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Description (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="description-id"
          >
            <input
              v-model="item.description.id"
              v-validate="'required'"
              name="description_id"
              data-vv-as="Description (Bahasa)"
              id="description-id"
              class="form-control"
              placeholder="Description in Bahasa"
            />
            <b-form-invalid-feedback id="input-description_id-feedback">{{
              veeErrors.first("description_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Type"
            class="required"
            label-for="input-1"
          >
            <b-form-radio-group
              id="type"
              v-model="item.type"
              :options="optionTypes"
              name="type"
              v-validate="'required'"
              data-vv-as="Type"
              class="custom-radio-check"
            ></b-form-radio-group>
            <p style="color:#e74a3b;width:100%;margin-top:.25rem;font-size:80%;">{{ veeErrors.first('type') }}</p>
          </b-form-group>
          <span v-if="item.type === 'other'">
            <input
              v-model="other_type"
              name="other_type"
              id="other_type"
              class="form-control"
              placeholder="Other Type"
            />
          </span>
        </b-col>
      </b-row>
      <br />
      <h5 class="font-weight-bold">Parameter</h5>
      <div v-for="(parameter, index) in item.parameters" :key="'param'+index">
        <b-row align-v="center">
          <b-col>
            <b-form-group
              id="fieldset-1"
              label="Key"
              label-class="control-label"
              class="required"
              label-for="input-1"
            >
              <input
                v-validate="'required'"
                v-model="parameter.key"
                :name="'key'+index"
                data-vv-as="Key"
                id="input-1"
                class="form-control"
                placeholder="Key"
              />
              <b-form-invalid-feedback id="input-key-feedback">{{ veeErrors.first('key'+index) }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label="Value"
              label-class="control-label"
              class="required"
              label-for="input-1"
            >
              <input
                v-model="parameter.value"
                v-validate="'required'"
                :name="'value'+index"
                data-vv-as="Value"
                id="input-1"
                class="form-control"
                placeholder="Value"
              />
              <b-form-invalid-feedback id="input-value-feedback">{{ veeErrors.first('value'+index) }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-link
              style="text-decoration: none;"
              class="text-danger"
              @click="removeParameter(index)"
              v-show="index || ( !index && item.parameters.length > 1)"
            >
              <i class="far fa-trash-alt"></i> Remove
            </b-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <b-button
              block
              variant="outline-primary"
              @click="addParameter()"
              v-show="index == item.parameters.length-1"
            >
              <i class="fas fa-plus"></i> Add more field
            </b-button>
          </b-col>
        </b-row>
      </div>
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <router-link :to="{ name: 'MasterProvider' }">
            <b-button :disabled="loading" class="col-2 mr-3" variant="outline-secondary" size="lg">CANCEL</b-button>
          </router-link>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="col-2"
            size="lg"
          >
            CREATE
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      item: {
        gateway: "",
        brand_name: "",
        type: "",
        description: {
          en: "",
          id: "",
        },
        parameters: [{
          key: "",
          value: "",
        }],
      },
      optionTypes: [
        { text: "Telco", value: 'telco' },
        { text: "Other", value: 'other' },
      ],
      other_type: "",
      loading: false,
    };
  },
  methods: {
    addParameter() {
      this.item.parameters.push({
        key: "",
        value: ""
      });
    },
    removeParameter(index) {
      this.item.parameters.splice(index, 1);
    },
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("gateway", this.item.gateway);
          formData.append("brand_name", this.item.brand_name);
          formData.append("description_id", this.item.description.id);
          formData.append("description_en", this.item.description.en);
          if (this.item.type === 'other' && this.other_type !== '') {
            formData.append("type", this.other_type);
          } else {
            formData.append("type", this.item.type);
          }
          this.item.parameters.forEach((parameter, index) => {
            formData.append("provider[parameter][sequence]", index);
              formData.append(
                `provider[parameter][${index}][key]`,
                parameter.key
              );
              formData.append(
                `provider[parameter][${index}][value]`,
                parameter.value
              );
          });
          this.$store
            .dispatch("MasterProviderModule/postMasterProvider", formData)
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: "MasterProvider" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500,
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    }
  },
};
</script>